import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/matt-foxx-IUY_3DvM__w-unsplash.jpeg";

function PraktiskVeikartPDF() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.roadmapPDF.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.roadmapPDF.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/praktisk-veikart-pdf"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.roadmapPDF.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.roadmapPDF.description")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.roadmapPDF.date")}
          </p>
        </div>
        <div className="w-full md:w-3/5">
          <img
            src={article_img}
            className="w-full"
            alt={i18next.t("pages.articles.list.roadmapPDF.imageAlt")}
          />
          <p className="text-sm text-secondary mt-2">
            {i18next.t("pages.articles.credit.photoBy")}{" "}
            <a
              href="https://nor01.safelinks.protection.outlook.com/?url=https%3A%2F%2Funsplash.com%2F%40foxxmd%3Futm_source%3Dunsplash%26utm_medium%3Dreferral%26utm_content%3DcreditCopyText&data=05%7C02%7Cj.ugland%40xperconsulting.no%7C8906d0161ed04d0a6ea208de3c8cf5c6%7C6051a23802de4cb0a8c56136b6c8c676%7C0%7C0%7C639014773593768647%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=HKto9pW8SsXj4QbriPu66igyCysSf%2FLtqUuIPDHhBEQ%3D&reserved=0"
              className="underline hover:text-contrast-ink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Matt Foxx
            </a>{" "}
            {i18next.t("pages.articles.credit.on")}{" "}
            <a
              href="https://nor01.safelinks.protection.outlook.com/?url=https%3A%2F%2Funsplash.com%2Fphotos%2Fasphalt-road-between-trees-IUY_3DvM__w%3Futm_source%3Dunsplash%26utm_medium%3Dreferral%26utm_content%3DcreditCopyText&data=05%7C02%7Cj.ugland%40xperconsulting.no%7C8906d0161ed04d0a6ea208de3c8cf5c6%7C6051a23802de4cb0a8c56136b6c8c676%7C0%7C0%7C639014773593806799%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=pDSraI2Bump5H1rgx8zLmpflWGNL6R%2BP2pBnZqgO58k%3D&reserved=0"
              className="underline hover:text-contrast-ink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Unsplash
            </a>
          </p>
        </div>
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            <p>{i18next.t("pages.articles.list.roadmapPDF.sections.intro.content1")}</p>
            <p>{i18next.t("pages.articles.list.roadmapPDF.sections.intro.content2")}</p>
            <p>{i18next.t("pages.articles.list.roadmapPDF.sections.intro.content3")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.roadmapPDF.sections.startWhy.title")}
            </h2>
            <p className="mb-2">
              {i18next.t("pages.articles.list.roadmapPDF.sections.startWhy.intro")}
            </p>
            <ul className="list-disc list-outside ml-10 my-4">
              <li>
                <b>{i18next.t("pages.articles.list.roadmapPDF.sections.startWhy.q1.title")}</b>{" "}
                {i18next.t("pages.articles.list.roadmapPDF.sections.startWhy.q1.content")}
              </li>
              <li>
                <b>{i18next.t("pages.articles.list.roadmapPDF.sections.startWhy.q2.title")}</b>{" "}
                {i18next.t("pages.articles.list.roadmapPDF.sections.startWhy.q2.content")}
              </li>
              <li>
                <b>{i18next.t("pages.articles.list.roadmapPDF.sections.startWhy.q3.title")}</b>{" "}
                {i18next.t("pages.articles.list.roadmapPDF.sections.startWhy.q3.content")}
              </li>
            </ul>
            <p>{i18next.t("pages.articles.list.roadmapPDF.sections.startWhy.closing")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.roadmapPDF.sections.assess.title")}
            </h2>
            <p className="mb-2">
              {i18next.t("pages.articles.list.roadmapPDF.sections.assess.intro")}
            </p>
            <p className="mb-2">
              <b>{i18next.t("pages.articles.list.roadmapPDF.sections.assess.quality.title")}</b>{" "}
              {i18next.t("pages.articles.list.roadmapPDF.sections.assess.quality.content")}
            </p>
            <p className="mb-2">
              <b>{i18next.t("pages.articles.list.roadmapPDF.sections.assess.workflows.title")}</b>{" "}
              {i18next.t("pages.articles.list.roadmapPDF.sections.assess.workflows.content")}
            </p>
            <p className="mb-2">
              {i18next.t("pages.articles.list.roadmapPDF.sections.assess.note")}
            </p>
            <p>
              {i18next.t("pages.articles.list.roadmapPDF.sections.assess.check.content1")}
              <a href="/skjema/kontakt-oss" className="underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.roadmapPDF.sections.assess.check.link")}
              </a>
              {i18next.t("pages.articles.list.roadmapPDF.sections.assess.check.content2")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.roadmapPDF.sections.method.title")}
            </h2>
            <p className="mb-2">
              {i18next.t("pages.articles.list.roadmapPDF.sections.method.intro")}
            </p>
            <ol className="list-decimal list-outside ml-10 my-4">
              <li className="mb-2">
                <b>{i18next.t("pages.articles.list.roadmapPDF.sections.method.m1.title")}</b><br/>
                {i18next.t("pages.articles.list.roadmapPDF.sections.method.m1.content")}
              </li>
              <li className="mb-2">
                <b>{i18next.t("pages.articles.list.roadmapPDF.sections.method.m2.title")}</b><br/>
                {i18next.t("pages.articles.list.roadmapPDF.sections.method.m2.content")}
              </li>
              <li>
                <b>{i18next.t("pages.articles.list.roadmapPDF.sections.method.m3.title")}</b><br/>
                {i18next.t("pages.articles.list.roadmapPDF.sections.method.m3.content1")}
                <a href="/docengine" className="underline hover:text-contrast-ink font-bold">
                  {i18next.t("pages.articles.list.roadmapPDF.sections.method.m3.link")}
                </a>
                {i18next.t("pages.articles.list.roadmapPDF.sections.method.m3.content2")}
              </li>
            </ol>
            <p className="mb-0">{i18next.t("pages.articles.list.roadmapPDF.sections.method.m3.content3")}</p>
            <ul className="list-disc list-outside ml-16 my-2 space-y-2">
              <li>{i18next.t("pages.articles.list.roadmapPDF.sections.method.m3.points.1")}</li>
              <li>{i18next.t("pages.articles.list.roadmapPDF.sections.method.m3.points.2")}</li>
              <li>{i18next.t("pages.articles.list.roadmapPDF.sections.method.m3.points.3")}</li>
              <li>{i18next.t("pages.articles.list.roadmapPDF.sections.method.m3.points.4")}</li>
            </ul>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.roadmapPDF.sections.plan.title")}
            </h2>
            <p className="mb-2">
              {i18next.t("pages.articles.list.roadmapPDF.sections.plan.intro")}
            </p>
            <ol className="list-decimal list-outside ml-10 my-4 space-y-2">
              <li>{i18next.t("pages.articles.list.roadmapPDF.sections.plan.steps.1")}</li>
              <li>{i18next.t("pages.articles.list.roadmapPDF.sections.plan.steps.2")}</li>
              <li>{i18next.t("pages.articles.list.roadmapPDF.sections.plan.steps.3")}</li>
              <li>{i18next.t("pages.articles.list.roadmapPDF.sections.plan.steps.4")}</li>
            </ol>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.roadmapPDF.sections.benefits.title")}
            </h2>
            <p className="mb-2">
              {i18next.t("pages.articles.list.roadmapPDF.sections.benefits.intro")}
            </p>
            <ul className="list-disc list-outside ml-10 my-4 space-y-2">
              <li>{i18next.t("pages.articles.list.roadmapPDF.sections.benefits.points.1")}</li>
              <li>{i18next.t("pages.articles.list.roadmapPDF.sections.benefits.points.2")}</li>
              <li>{i18next.t("pages.articles.list.roadmapPDF.sections.benefits.points.3")}</li>
              <li>{i18next.t("pages.articles.list.roadmapPDF.sections.benefits.points.4")}</li>
              <li>{i18next.t("pages.articles.list.roadmapPDF.sections.benefits.points.5")}</li>
              <li>{i18next.t("pages.articles.list.roadmapPDF.sections.benefits.points.6")}</li>
            </ul>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.roadmapPDF.sections.howStart.title")}
            </h2>
            <p className="mb-2">
              {i18next.t("pages.articles.list.roadmapPDF.sections.howStart.intro")}
            </p>
            <ol className="list-decimal list-outside ml-10 my-4 space-y-2">
              <li>
                <b>{i18next.t("pages.articles.list.roadmapPDF.sections.howStart.s1.title")}</b><br/>
                {i18next.t("pages.articles.list.roadmapPDF.sections.howStart.s1.content1")}
              </li>
              <li>
                <b>{i18next.t("pages.articles.list.roadmapPDF.sections.howStart.s2.title")}</b><br/>
                {i18next.t("pages.articles.list.roadmapPDF.sections.howStart.s2.content")}
              </li>
              <li>
                <b>{i18next.t("pages.articles.list.roadmapPDF.sections.howStart.s3.title")}</b><br/>
                {i18next.t("pages.articles.list.roadmapPDF.sections.howStart.s3.content")}
              </li>
            </ol>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.roadmapPDF.sections.summary.title")}
            </h2>
            <p className="mb-2">
              {i18next.t("pages.articles.list.roadmapPDF.sections.summary.content1")}
            </p>
            <p className="mb-2">
              {i18next.t("pages.articles.list.roadmapPDF.sections.summary.content2")}
            </p>
            <p className="mt-6">
              {i18next.t("pages.articles.list.roadmapPDF.sections.cta.content")} 
            </p>
            <a href="/skjema/kontakt-oss" className="font-bold underline hover:text-contrast-ink  mt-0">
                {i18next.t("pages.articles.list.roadmapPDF.sections.cta.link")}
              </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PraktiskVeikartPDF;


